import { render, staticRenderFns } from "./ProductCatalog.vue?vue&type=template&id=859e602a&scoped=true"
import script from "./ProductCatalog.vue?vue&type=script&lang=js"
export * from "./ProductCatalog.vue?vue&type=script&lang=js"
import style0 from "./ProductCatalog.vue?vue&type=style&index=0&id=859e602a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859e602a",
  null
  
)

export default component.exports